import { useSelector } from 'react-redux'
import { selectUserPermission } from '../store/user'
import { isEqual } from '../util/isEqual'
import { User } from '../models/client/user'

export const useAuthorized = (...authorizedPermissions: User['permissions']): boolean => {
    const userPermissions = useSelector(selectUserPermission, isEqual)
    const permissionSet = new Set(userPermissions)
    let approvedPermissionCount = 0
    authorizedPermissions.forEach((permissionKey) => {
        if (permissionSet.has(permissionKey)) {
            approvedPermissionCount += 1
        }
    })
    return approvedPermissionCount === authorizedPermissions.length
}
